import { render, staticRenderFns } from "./submissionsList.vue?vue&type=template&id=d424233c&"
import script from "./submissionsList.vue?vue&type=script&lang=js&"
export * from "./submissionsList.vue?vue&type=script&lang=js&"
import style0 from "./submissionsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports